import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';

import PromptTranslate from "../../PromptTranslate/PromptTranslate";

import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "../DiffusionOptionsDesc/DiffusionOptionsDesc.css";

import TextInputImage from "../../../image/for-style-change/for-about/sch-turban-woman-input-h125.jpeg"
import TextMaskImage from "../../../image/for-style-change/for-about/sch-turban-woman-mask-h100.jpeg"
import TextStyleImage from "../../../image/for-style-change/for-about/sch-style-oil-painting-h100.jpeg";
import TextOutputImage1 from "../../../image/for-style-change/option-description/text/manwoman-output-oil-style-text1-h125.jpeg";
import TextOutputImage2 from "../../../image/for-style-change/option-description/text/manwoman-output-oil-style-text2-h125.jpeg";

function StyleChangeDescText() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
            {t('inpaintEditor07', "Describe what you want to draw... (accept English, please use translation for other languages")}
            .{' '}{t('promptTranslate08', 'Or, use translastion shown below')})
            <br/>
            {t('syleChangeOptions13', 'By adding description of objects in Input image and style of Style image, better output images are generated.')} 
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={TextInputImage}
              />
              {t('aboutPage.13', 'Input image')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={TextMaskImage}
              />
              {t('aboutStyleChange05', 'Selected part')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={TextStyleImage}
              />
              {t('aboutStyleChange06', 'Style image')} (oil painting)
            </div>
          </div>
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">

            <div>
              <img className="diffsionOptionDescImage"
                src={TextOutputImage1}
              />
              a man wearing turban, oil painting style
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={TextOutputImage2}
              />
              a woman wearing turban, oil painting style
            </div>
          </div>
        </div>

        <PromptTranslate />
      </div>
    )
  }


export default StyleChangeDescText